import React from "react";
import Nabvar from "../common/Nabvar";
import Sidebar from "../common/Sidebar";
import Body from "../ui/Body";
import Getallcoupon from "./coupon/Getallcoupon";

export default function GetAllcoupon() {
  return (
    <>
      <Sidebar />
      <Nabvar />
      <Body>
        <Getallcoupon />
      </Body>
    </>
  );
}
